export default __webpack_public_path__ + "static/house-820f5e6a4cd63a02269c1e68d3be67ee.png";